export function prepareFacets(facets) {
    const formattedFacets = {};

    const allowedFacets = [
        'brand',
        'color',
        'department',
        'pattern',
        'price',
        'size',
        'series',
    ];

    Object.entries(facets).forEach(([ facetKey, facet ]) => {
        if (facetKey.startsWith('utm_')) {
            return;
        }

        if (!allowedFacets.includes(facetKey) && !facetKey.startsWith('variant') ) {
            return;
        }

        if (typeof facet === 'string' && facet.startsWith('min:')) {
            const [ minPart, maxPart ] = facet.split(',');
            formattedFacets[facetKey] = {
                min: parseInt(minPart?.replace('min:', ''), 10) || null,
                max: parseInt(maxPart?.replace('max:', ''), 10) || null,
            };
        } else if (typeof facet === 'string') {
            formattedFacets[facetKey] = facet.split(',');
        } else if (Array.isArray(facet)) {
            formattedFacets[facetKey] = facet; // already array
        } else if (facet != null) {
            formattedFacets[facetKey] = [ String(facet) ];
        } else {
            formattedFacets[facetKey] = [];
        }
    });

    return formattedFacets;
}

export function getMainVariant(product) {
    let mainSku = product?.key?.split('-')[1];
    let mainVariant = product?.variants?.find((variant) => variant.key === mainSku);
    return mainVariant && mainVariant.inStock ? mainVariant : product?.variants?.filter((variant) => variant.inStock)[0] || mainVariant;
}

export function getProductVariants(product) {
    let allVariants = product.variants.filter((variant) => variant.label).map((variant) => {
        return variant.label;
    });

    return allVariants.length > 0;
}

export function getPreferImageType(product) {
    const key = 'prefer_environment_image';
    if (product?.variants?.length === 1) {
        return product?.variants[0]?.custom?.[key][0]?.id === '1' ? 'environment' : 'standard';
    }

    if (product?.variants?.length > 0) {
        return getMainVariant(product)?.custom?.[key][0]?.id === '1' ? 'environment' : 'standard';
    }

    return product?.custom?.[key][0]?.id === '1' ? 'environment' : 'standard';
}

export function getUUID(product) {
    if (product?.variants?.length === 1) {
        return product?.variants[0]?.custom?.uuid[0]?.id;
    }

    if (product?.variants?.length > 0) {
        return getMainVariant(product)?.custom?.uuid[0]?.id;
    }

    return product?.custom?.uuid[0]?.id;
}

export function getMarketingLabel(product) {
    const label = product?.custom?.marketing_label?.[0]?.id;

    if (!label) {
        return [];
    }

    return [ label ];
}

export function getDeliveryTimeId(product) {
    if (product?.variants?.length > 0) {
        product = getMainVariant(product);
    }

    return product?.custom?.delivery_time?.[0] || null;
}

export function getStock(product) {
    return product.custom?.in_stock ? parseInt(product.custom.in_stock[0].label) : 0;
}

export function getFastDelivery(product) {
    return !!product.custom?.fast_delivery_available;
}

export function preventFloatRoundingIssues(price, listPrice) {
    let centPrice = parseInt(price * 100);
    let centListPrice = parseInt(listPrice * 100);

    return parseInt(Math.round(100 * (centListPrice - centPrice) / centListPrice));
}
